import { useParams } from "react-router-dom";
import left_arrow4 from "../../../../assets/case_study/case_arrow4_section5.png"
import left_arrow5 from "../../../../assets/case_study/case_arrow5_section5.png"
import left_arrow6 from "../../../../assets/case_study/case_arrow_section5.svg"

const CaseStudySection5 = {
    phenom: {
        top_para: "Phenom subscribed to the following verifications services from Hirestar: ",
        bottom_para: "All services were full integrated with Phenom’s HR System, monitored for quality, and completely aligned with Phenom’s Standard Operating Procedures (SOPs).",
        content1: "Criminal background checks",
        content2: "Employment history and education verification (directly integrated with 250+ universities)",
        content3: "Address and ID validation using Aadhaar and other national databases",
        content4: "NDNC and driver’s license verifications, adhering strictly to compliance SOPs",
        left_image: left_arrow4
    },
    goken: {
        top_para: "Behind every streamlined report and accelerated TAT was a meticulously designed and automated verification engine tailored for Goken’s diverse workforce.",
        bottom_para: "All data was delivered in real-time via custom dashboards — structured, reliable, and compliant.",
        content1: "Criminal Verification – Local police record checks and court database scans.",
        content2: "Employment Verification – Role-specific tenure and designation validation, with flagged discrepancies auto-escalated.",
        content3: "Education Verification – University tie-ups + UGC-certified degree checks with embedded proof.",
        content4: "Address Verification – AI-driven live photo capture with geo-tagging for both permanent and current addresses.",
        content5: "Identity Check – Real-time Aadhaar validation with OTP & image match, plus PAN and voter ID sync.",
        content6: "Medical Fitness – Pre-placement medical check integrations for Goken’s compliance-heavy roles.",
        left_image: left_arrow6
    },
    ikf: {
        top_para: "Our verifications included:",
        bottom_para: "All reports were delivered via real-time dashboards, ensuring transparency and traceability.",
        content1: "Identity checks (PAN, Aadhaar, Voter ID)",
        content2: "Address verification with geo-tagged visits and timestamped photos",
        content3: "Criminal record screening (local and national)",
        content4: "Education, employment, and credit history",
        content5: "AI-led document analysis and social media risk flags",
        content6: "Medical check integrations for selected roles",
        left_image: left_arrow6
    },
    monitra: {
        top_para: "Hirestar.io mapped out a healthcare-specific BGV workflow that included: ",
        bottom_para: "All data was delivered in real-time via custom dashboards — structured, reliable, and compliant.",
        content1: "Aadhaar, PAN, DL, education, address, and criminal background checks",
        content2: "Verification of licenses with medical councils and nursing boards",
        content3: "AI-based document validation with blockchain-secured audit trails",
        content4: "Mobile-first face verification and multilingual UI (Telugu-enabled)",
        content_5: "Integrated access to 200+ medical test panels and reports",
        left_image: left_arrow5
    },
    incuspaze: {
        top_para: "Hirestar.io deployed a range of checks customized to Incuspaze’s use cases:",
        bottom_para: "Every element was implemented with a focus on automation, compliance, and zero operational drag.",
        content1: "Individual checks: Aadhaar, DL, PAN, criminal background, address, and identity verification",
        content2: "Company checks: GSTIN, CIN, DIN, Corporate PAN, entity blacklisting, and MSA detail verification",
        content3: "Visitor checks: Instant face match + ID verification at check-in, without coding or third-party tools",
        content4: "Compliance-First Workflows: All reports were tamper-proof and audit-ready via our Blockchain-backed verification engine",
        left_image: left_arrow4
    },
}

export default function PhenomCaseSection5() {
    const { companyName } = useParams();
    const companyData = CaseStudySection5[companyName];

    if (!companyData) return <div>Invalid company</div>;

    const { top_para, bottom_para, left_image } = companyData;

    // Dynamically collect all `content` fields
    const contentItems = Object.entries(companyData)
        .filter(([key]) => key.startsWith("content"))
        .sort(([a], [b]) => {
            const aNum = parseInt(a.match(/\d+/));
            const bNum = parseInt(b.match(/\d+/));
            return aNum - bNum;
        });

    return (
        <section className="mx-4  flex items-center justify-center py-10">
            <div className="max-w-6xl mx-auto text-center">

                {/* Heading */}
                <h2 className="text-[32px] md:text-[40px] font-semibold mb-4">
                    The Execution
                </h2>

                {/* Top paragraph */}
                <p className="text-[18px] md:text-[20px] mb-8">
                    {top_para}
                </p>

                {/* Image + Cards Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-center">

                    {/* Left Image */}
                    <div className="rounded-lg  p-2 flex items-center justify-center h-full">
                        <img
                            src={left_image}
                            alt="Execution Illustration"
                            className="h-full w-auto object-contain  p-6 section5_left_image"
                        />
                    </div>


                    {/* Right Cards */}
                    <div className="rounded-lg   p-6 flex items-center justify-center">
                        <div className="grid grid-cols-1 gap-6 mx-auto w-full">
                            {contentItems.map(([key, value], idx) => (
                                <div key={idx} className="rounded-lg shadow-lg  p-6 text-left">
                                    <p className="text-[18px] font-normal">{value}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>

                {/* Bottom paragraph */}
                {bottom_para && (
                    <p className="text-[18px] md:text-[20px] mt-10">
                        {bottom_para}
                    </p>
                )}
            </div>
        </section>
    );
}
